import React, { useEffect, useState } from "react";
import axios from "axios";
import { Siren } from "lucide-react";
import { useFloatingWindows } from "@/lib/floatingWindows";

/** Header count of open problems; opens the Problems Inbox card. */
export function ProblemsBadge() {
  const [n, setN] = useState(null);
  const { openWindow } = useFloatingWindows();
  useEffect(() => {
    const load = () => axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/problems`, { headers: { Authorization: `Bearer ${localStorage.getItem("nex_token")}` } })
      .then((r) => setN(r.data.total)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener("problems:changed", load);
    return () => { clearInterval(t); window.removeEventListener("problems:changed", load); };
  }, []);
  if (n === null) return null;
  return (
    <button type="button" onClick={() => openWindow("ops_problems", { title: "Problems Inbox" })} data-testid="problems-badge"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border font-mono text-[10px] tracking-[0.16em] uppercase transition-colors ${n ? "border-amber-400/50 text-amber-200 hover:bg-amber-500/10" : "border-white/10 text-nex-muted"}`}>
      <Siren className="h-3 w-3" /> {n} problem{n === 1 ? "" : "s"}
    </button>
  );
}
